import React from "react";
import "./ContactFormCTASection.css";
import { FaGoogle } from "react-icons/fa";

const ContactFormCTASection = () => {
  return (
    <section className="contact-form-cta">
      <div className="cta-inner">
        <div className="cta-content">
          <h2>
            Want to Know More About <span>MBR Network’s?</span>
          </h2>
          <p>
            Fill out our simple Google Form to explore our programs,
            internships, and career-building opportunities. Be a part of a
            growing network of learners, creators, and professionals shaping the
            future.
          </p>

          <a
            href="https://forms.gle/your-google-form-link"
            target="_blank"
            rel="noreferrer"
            className="btn-form"
          >
            <FaGoogle className="google-icon" /> Fill the Google Form
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactFormCTASection;
